/**
 * Service pour le diagnostic automatique
 */

import api from './api.js';

/**
 * Effectuer le diagnostic pour un bénéficiaire
 */
export async function effectuerDiagnostic(beneficiaireId, reponses) {
  const response = await api.post(`/diagnostic/${beneficiaireId}`, {
    reponses,
  });
  return response.data;
}

/**
 * Obtenir le diagnostic d'un bénéficiaire
 */
export async function obtenirDiagnostic(beneficiaireId) {
  const response = await api.get(`/diagnostic/${beneficiaireId}`);
  return response.data;
}

/**
 * Obtenir les définitions des cas
 */
export async function obtenirDefinitionsCas() {
  const response = await api.get('/diagnostic/cas/definitions');
  return response.data;
}
